import React, { useState } from 'react';
import './About.css';

const About = () => {
  const [activeTab, setActiveTab] = useState('skills');

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <h1 className="section-title">About Me</h1>
          <p>
            I'm a junior year student pursuing B.Tech in Computer Science at IIITDM Kancheepuram.
            Passionate about tech and innovation, I delve into software development and algorithms.
            Eager to solve real-world problems and contribute to technology's evolution.
          </p>
          
          <div className="tab-titles">
            <button 
              className={`tab-link ${activeTab === 'skills' ? 'active' : ''}`}
              onClick={() => setActiveTab('skills')}
            >
              Skills
            </button>
            <button 
              className={`tab-link ${activeTab === 'education' ? 'active' : ''}`}
              onClick={() => setActiveTab('education')}
            >
              Education
            </button>
          </div>

          <div className="tab-contents">
            {activeTab === 'skills' && (
              <div className="tab-content">
                <ul>
                  <li>
                    <span>Languages</span>
                    <br />C, C++, Python, SQL, HTML/CSS, Assembly (MASM), Verilog
                  </li>
                  <li>
                    <span>Frameworks/Libraries</span>
                    <br />NumPy, Pandas, OpenCV, TensorFlow, PyTorch, Django, Flask, Matplotlib, Angular
                  </li>
                  <li>
                    <span>Tools/Platforms</span>
                    <br />Git, GitHub, Linux, VS Code, MySQL, PostgreSQL, LaTeX
                  </li>
                </ul>
              </div>
            )}

            {activeTab === 'education' && (
              <div className="tab-content">
                <ul>
                  <li>
                    <span>B.Tech (Hons), Computer Science and Engineering<br />2022 - Expected 2026</span>
                    <br />Indian Institute of Information Technology, Design and Manufacturing Kancheepuram
                    <br />Chennai, India
                    <br />CGPA: 9.26/10.0
                  </li>
                  <li>
                    <span>Intermediate Maths, Physics, Chemistry<br />2020-2022</span>
                    <br />Sri Chaitanya Junior Kalasala, Hyderabad
                    <br />Marks: 985/1000
                  </li>
                  <li>
                    <span>Grade 10th<br />2020</span>
                    <br />Dr. KKR's Gowtham Concept School, Hyderabad
                    <br />CGPA: 10.0/10.0
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        
        <div className="about-decoration">
          <div className="decoration-box">
            <i className="fa-solid fa-code"></i>
            <h3>Clean Code</h3>
            <p>Writing maintainable and efficient code</p>
          </div>
          <div className="decoration-box">
            <i className="fa-solid fa-lightbulb"></i>
            <h3>Problem Solver</h3>
            <p>Analytical thinking and creative solutions</p>
          </div>
          <div className="decoration-box">
            <i className="fa-solid fa-rocket"></i>
            <h3>Fast Learner</h3>
            <p>Quick to adapt to new technologies</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
